import * as React from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Typography,
} from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import healthImg from "../../../image/design-assets/HealthCondition.svg";
import { Avatar } from "@mui/material";

export default function MedicationSummary() {
  return (
    <Card style={{ borderRadius: 20, height: "100%" }}>
      <CardHeader
        title={
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Grid item>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                Health Condition
              </Typography>
            </Grid>
          </Grid>
        }
      />
      <CardContent>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="stretch"
        >
          <Grid item>
            <Avatar>
              <img
                alt="medicine Life"
                src={healthImg}
                style={{
                  width: 70,
                  height: 60,
                }}
              />
            </Avatar>
          </Grid>
          <Grid item>
            <Typography variant="body1">
              Based On Single Day observation and Input shared By Patient.
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="h6">HEALTHY</Typography>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={1}
            >
              <Grid item>
                <Button
                  variant="text"
                  endIcon={<ArrowRightAltIcon />}
                  sx={{ textTransform: "none" }}
                >
                  View All
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
}
